<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-Loading="isLoadingPage">
        <div slot="body">
          <bita-form ref="form">
              <div slot="body">
                <div class="row">
                  <bita-select
                      ref="allDriverSelect"
                      name="alldriver"
                      label="ارسال به همه رانندگان"
                      validation-container-class="col-4"
                      input-class="form-control"
                      :data-source="sendToAll"
                      data-text-field="title"
                      data-value-field="id"
                      v-model="allDriver"
                      @change="selectAllDriver"
                />
                  <bita-multiselect
                      v-if="allDriver == 0"
                      ref="userSelect"
                      name="user"
                      label="انتخاب راننده"
                      validation-container-class="col-4"
                      input-class="form-control"
                      :data-source="users"
                      data-text-field="full_name_phone"
                      data-value-field="id"
                      v-model="userID"
                      @change="selectDriver"
                  />
                </div>
                <div class="row">
                    <bita-select
                        ref="notificationType"
                        name="notification_type"
                        label="نوع پیام"
                        rule=""
                        validation-container-class="col-3"
                        input-class="form-control"
                        :data-source="notificationType"
                        data-text-field="name"
                        data-value-field="id"
                        v-model="formData.type"
                    />
                    <bita-input
                        type="text"
                        name="title"
                        ref="title"
                        rules="required"
                        label="عنوان پیام"
                        input-class="form-control"
                        validation-container-class="col-3"
                        v-model="formData.title"
                    />
                    <bita-input
                        type="text"
                        name="url"
                        ref="url"
                        rules=""
                        label="لینک"
                        input-class="form-control"
                        validation-container-class="col-3"
                        v-model="formData.url"
                    />
                    <bita-uploader
                      name="banner"
                      label="تصویر"
                      ref="banner"
                      rules="size:50"
                      validation-container-class="col-3"
                      input-class="form-control"
                      v-model="formData.banner"
                    />
                    <bita-textarea
                      name="message"
                      rules="required"
                      label="متن پیام"
                      validation-container-class="col-12"
                      input-class="form-control"
                      place-holder="پیام"
                      v-model="formData.message"
                    />
                    <div class="col-3 mb-3">
                      <bita-bootbutton
                        type="primary"
                        title="ارسال"
                        btn-width="150px"
                        @click.native="handleSendMessage"
                      />
                    </div>
                </div>
              </div>
          </bita-form>
          <bita-grid
            v-if="showGrid"
            ref="grid"
            :is-loading="isLoadingGrid"
            :columns="gridColumns"
            :read-data="readData"
            :hasRow="false"
            :resizable="true"
            :grid-server-side="false"
            :batch="true"
            :has-row-number="false"
          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>
<script>
export default {
    data() {
        return {
            breadCrumbs: [
              {title: "صفحه اصلی", link: "/"},
              {title: "ارسال پیام خصوصی", link: "/notifications/send"},
            ],
            isLoadingPage: false,
            isLoadingGrid: false,
            showGrid: false,
            showForm: true,
            users: [],
            userID: '',
            allDriver: 1,
            formData: {},
            sendToAll: [
              { id: 1, title: "بله" },
              { id: 0, title: "خیر" },
            ],
            notificationType: [
              { id: 'NS4', name: 'پیغام شخصی' },
              { id: 'NS5', name: 'آموزش' }
            ]
        }
    },
    computed: {
      gridColumns(){
        return [
          { title: "#", template: this.$getTemplate, width: "40px" },
          { field: "created_at", title: "زمان ارسال", template: (e) => (e.created_at ? this.$getJalaliDateTime(e.created_at) : "-"), width: "170px"},
          { filed: "state", title: "وضعیت", template: (e) => (e.notification_log_state ? e.notification_log_state : "-"), width: "100px"},
          { filed: "send_via", title: "ارسال با", template: (e) => (e.send_via ? e.send_via : "-"), width: "100px"},
          { field: "message", title: "متن پیام", template: (e) => (e.message ? e.message : "-")},
        ]
      }
    },
    mounted(){
        Promise.all([
            this.getUsers(),
        ]).then((res) => {
            this.users = res[0].data;
        })
    },
    methods: {
        getUsers() {
            return this.$persistClient("get", "users?filter[type]=Driver");
        },
        readData(e){
          this.isLoadingGrid = true;
          let url = `notifications?user=${this.userID}&type=NS4,NS5`
          this.$persistClient("get", url)
          .then((res) => {
            e.success(res.data);
          })
          .finally((res) => {
            this.isLoadingGrid = false;
          })
        },
        loadData(){
          this.$refs.grid.loadDataSource();
        },
        handleSendMessage() {
          this.$refs.form.validate().then((result) => {
            if (result){
              let data = {
                title: this.formData.title,
                message: this.formData.message,
                type: this.formData.type,
                url: this.formData.url,
                banner: this.formData.banner,
                user_id: JSON.stringify(this.userID)
              };
              this.$persistClient("post", "notifications", this.$getFormData(data))
              .then((res) => {
                this.$izitoast("success","موفق", res.data.message);
                this.resetForm();
              })
              .finally((res) => {
                this.loadData();
              })
            }
          })
        },
        resetForm() {
          this.formData = {};
          this.allDriver = 1;
          this.$refs.notificationType ? this.$refs.notificationType.emptyKendo() : null;
          this.$refs.allDriverSelect ? this.$refs.allDriverSelect.emptyKendo() : null;
          this.$refs.userSelect ? this.$refs.userSelect.emptyKendo() : null;
          this.$refs.banner.reset();
          this.$refs.form.reset();
          this.selectAllDriver();
        },
        selectDriver() {
          this.showGrid = true;
          this.showForm = true;
        },
        selectAllDriver() {
          if ( this.allDriver != 1 ) {
            this.userID = 0;
            this.showGrid = false;
            this.showForm = false;
            return true;
          }
          this.userID = null;
          this.showForm = true;
          this.showGrid = false;
        }
    }
}
</script>